
import { getTestTitle as getMetadataTitle, getTestDescription as getMetadataDescription } from './metadata';

interface Test {
  id: string;
  title: string;
  description: string;
  icon: string;
}

/**
 * Get the title for a test by its ID for Level 1
 */
export const getTestTitle = (testId: string): string => {
  return getMetadataTitle(testId);
};

/**
 * Get the description for a test by its ID for Level 1
 */
export const getTestDescription = (testId: string): string => {
  return getMetadataDescription(testId);
};
